

function animateSubSections() {
  $('.sub-section').each(function(index, element) {
    animateIntroSubSection(this);
  });
}

function animateIntroSubSection(subsection) {
  var $this = $(subsection);

  var $subSectionTitle    = $this.find('.block-header').find('h5'),
      $subSectionNumber   = $this.find('.block-header').find('.number'),
      $subSectionLabel    = $this.find('.block-header').find('.label'),
      $subSectionP        = $this.find('.block-header').find('p'),
      numberSplit         = new SplitText($subSectionNumber, {type:"chars"});

  var introSubSectionTL   = new TimelineLite({paused: true});
  var numberTL = new TimelineLite({paused: true});

  TweenMax.set(numberSplit, {perspective:400});

  introSubSectionTL.from($subSectionTitle, 1, { opacity: 0, x: -20, ease: Power4.easeOut })
                   .staggerFrom($subSectionLabel, 0.5, { opacity: 0, y: -10, ease: Power4.easeOut }, 0.2, 0.6)
                   .staggerFrom($subSectionP, 0.5, { opacity: 0, y: -10, ease: Power4.easeOut }, 0.2, 0.7);

                    numberSplit.split({type:"chars"});

                    $(numberSplit.chars).each(function(index,el){
                      // numberTL.from($(el), 0.5, {opacity:0, force3D:true}, index * 0.1, 2);
                      numberTL.from($(el), 0.5, {opacity:0, force3D:true, y: -20, ease:Power4.easeOut}, index * 0.1, 2);
                    });

  var scene = new ScrollMagic.Scene({
    triggerElement: subsection,
    triggerHook: 0.5,
    offset: 0
  })
  .on('enter', function (event) {
    introSubSectionTL.play().timeScale(1);
    numberTL.play().timeScale(1);
  })
  .on('leave', function (event) {
    introSubSectionTL.reverse().timeScale(1.5);
    numberTL.reverse().timeScale(1.5);
  })
  .addTo(controller);

}